import React from "react";
import { Event, PageConfigurationContextConsumer } from "./index";
import ajax from "superagent";
import _ from "lodash";
import "./styles/get-notified-popup.css";
import * as EmailValidator from "email-validator";
// @ts-ignore
import Pluralize from "react-pluralize";
import moment from "moment";
import BellIcon from "./BellIcon";
import ContrastForegroundUtility from "../../utils/ContrastForegroundUtility";

const closeIcon = require("./styles/remove.svg");

const GetNotifiedPopup = ({
  events,
  bulkRegisterCustomerLeadAPI,
  clearSelection
}: {
  events: Event[];
  bulkRegisterCustomerLeadAPI: string;
  clearSelection: () => void;
}) => {
  const customerEmailField: any = React.createRef();

  const registerCustomerInterest = () => {
    const email = customerEmailField.current.value;
    if (EmailValidator.validate(email))
      ajax
        .post(bulkRegisterCustomerLeadAPI)
        .send({
          event_ids: _.map(events, "id"),
          email
        })
        .then(res => {
          clearSelection();
          // @ts-ignore
          toastr.success("You have subscribed to the event");
        })
        .catch(e => {
          // @ts-ignore
          toastr.error("There was an error. Please try again.");
        });
    // @ts-ignore
    else toastr.error("The email you entered is not valid");
  };

  return (
    <PageConfigurationContextConsumer>
      {pageConfiguration =>
        pageConfiguration && (
          <div>
            <div
              id="get-notified-dialog"
              className="modal fade in"
              role="dialog"
            >
              <div className="modal-dialog get-notified-dialog-content">
                <div className="get-notified-content-div">
                  <img
                    src={closeIcon}
                    onClick={_ => clearSelection()}
                    className="get-notified-close-icon"
                  />
                  <div className="get-notified-icon-div">
                    <BellIcon color={pageConfiguration.primaryColor} />
                  </div>
                  <p className="get-notified-header">Get Notified</p>
                  <p className="get-notified-p">
                    Please enter your email to know when photos are uploaded to
                    the following{" "}
                    <Pluralize singular="event" count={events.length} />
                  </p>
                  <div className="get-notified-events">
                    {events.map(event => {
                      return (
                        <div className="get-notified-ev-card" key={event.id}>
                          <div
                            style={{
                              backgroundColor: pageConfiguration.primaryColor
                            }}
                            className={`get-notified-ev-date-badge ${ContrastForegroundUtility.fgClass(
                              pageConfiguration.primaryColor
                            )}`}
                          >
                            <p className="get-notified-ev-date-p1">
                              {event.day}
                            </p>
                            <p className="get-notified-ev-date-p2">
                              {event.month}
                            </p>
                            <p className="get-notified-ev-date-p3">
                              {event.year}
                            </p>
                          </div>
                          <div>
                            <p className="get-notified-ev-p1">{event.name}</p>
                            <p className="get-notified-ev-p2">
                              {event.location}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="get-notified-input-div">
                    <input
                      type="text"
                      placeholder="Please enter your email"
                      ref={customerEmailField}
                    />
                    <button
                      className={`get-notified-btn ${ContrastForegroundUtility.fgClass(
                        pageConfiguration.accentColor
                      )}`}
                      onClick={registerCustomerInterest}
                      style={{ backgroundColor: pageConfiguration.accentColor }}
                    >
                      {" "}
                      Notify me{" "}
                    </button>
                  </div>
                </div>
                <button
                  className="get-notified-cancel-btn"
                  onClick={clearSelection}
                >
                  {" "}
                  Cancel
                </button>
              </div>
            </div>{" "}
            <div className="modal-backdrop fade in" />
          </div>
        )
      }
    </PageConfigurationContextConsumer>
  );
};

export default GetNotifiedPopup;
